import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const RETRY_DELAYS_MS = [600, 1800];
const RETRY_STATUSES = new Set([502, 503, 504]);

// Transparent retry for idempotent GETs during ingress blips / deploy rollouts (network error or 502/503/504)
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  const status = error.response?.status;
  const transient = !error.response || RETRY_STATUSES.has(status);
  if (!cfg || (cfg.method || "get").toLowerCase() !== "get" || !transient) throw error;
  const attempt = cfg.__retryCount || 0;
  if (attempt >= RETRY_DELAYS_MS.length) throw error;
  cfg.__retryCount = attempt + 1;
  await new Promise((r) => setTimeout(r, RETRY_DELAYS_MS[attempt]));
  return api(cfg);
});

export default api;
